<template>
<span class="desc-block">
  <el-radio-group class="ordinary" v-model="timeType" @change="onChange">
    <el-radio-button v-if="fixedTimeType === null || fixedTimeType === analysisTimeType.CURRENT.value" :label="analysisTimeType.CURRENT.value">{{analysisTimeType.CURRENT.label}}</el-radio-button>
    <el-radio-button v-if="fixedTimeType === null || fixedTimeType === analysisTimeType.HIST.value"  :label="analysisTimeType.HIST.value">{{analysisTimeType.HIST.label}}</el-radio-button>
  </el-radio-group>
  <span v-show="timeType === analysisTimeType.HIST.value" class="mr-l10">
    <em>{{checkDatetimeString}}</em> 수집 정보입니다.
  </span>
  <span v-show="timeType === analysisTimeType.CURRENT.value" class="mr-l4">
    <el-button size="small" icon="fas fa-sync-alt" @click="onReload"></el-button>
  </span>
</span>
</template>

<script>
import isNil from 'lodash/isNil';
import { getDateToString } from '@/utils/date';
import { analysisTimeType } from '@/constants/performance';
import { EMPTY_TEXT } from '@/utils/string';
import { mapGetters } from 'vuex';

export default {
  name: 'WPerfAnalysisTimeInfo',
  props: {
    fixedTimeType: {
      type: String,
      default: null,
    },
    checkDatetime: {
      type: Number,
    },
  },
  computed: {
    checkDatetimeString() {
      return isNil(this.checkDatetime) ? EMPTY_TEXT : getDateToString(this.checkDatetime);
    },
    ...mapGetters(['selectedNode']),
  },
  data() {
    return {
      analysisTimeType,
      timeType: analysisTimeType.HIST.value,
    };
  },
  created() {
    if (this.fixedTimeType !== null) {
      this.timeType = this.fixedTimeType;
    }
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.fixedTimeType === null) {
          this.timeType = analysisTimeType[this.$store.state.common.analysisTimetype].value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getTimeType() {
      return this.timeType;
    },
    setTimeType(type) {
      if (type !== this.timeType && !isNil(this.timeType)) {
        this.timeType = type;
        this.$emit('change', type);
      }
    },
    onReload() {
      this.$emit('reload');
    },
    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/PerfAnalysisTimeInfo.vue